export function isSuitableForBinding(meta, schema) {
  if (!meta || !schema) return false;
  if (meta.checkData && !meta.checkData(schema)) return false;
  return true;
}
export function getRelatedPropsOfBinding(meta) {
  if (!meta) return [];
  return [meta.prop, meta.pathProp, meta.schemaProp, meta.stubProp].filter(Boolean);
}
//# sourceMappingURL=bindings.js.map
